// extracted by mini-css-extract-plugin
export default {"communicationsBox":"communications_communicationsBox__nbOg9"};